






import { defineComponent } from '@nuxtjs/composition-api';
import { BaseButton } from '@bambeehr/pollen';
import usePurchaseTrainingContent from '@/modules/Training/components/PurchaseTraining/usePurchaseTrainingContent';

export default defineComponent({
  name: 'PurchaseTrainingCta',
  components: {
    BaseButton,
  },
  setup() {
    const {
      purchaseButtonTextWithVariables,
      pending: trainingContentPending,
      trainingRegistrationContentMap,
    } = usePurchaseTrainingContent();

    return {
      purchaseButtonTextWithVariables,
      trainingRegistrationContentMap,
      isLoading: trainingContentPending,
    };
  },
});
